import { capitalizeFirstCharacter } from '../../helpers/string';
import { Occupation, OccupationResource } from './Occupations';

export const transformToOccupation = (
    occupationResource: OccupationResource,
): Occupation => ({
    id: occupationResource.id,
    label: capitalizeFirstCharacter(occupationResource.prefLabel),
    description: occupationResource.description,
    totalSkills: occupationResource.totalSkillCount,
    matchedSkills: occupationResource.matchedSkillCount,
    matchedPercentage: occupationResource.matchedPercentage,
});
